"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var tokens = {
  fontXSFamily: 'Helvetica Now Display',
  fontXSSize: '12px',
  fontXSLineHeight: '16px',
  fontXSSpacing: '0.3px',
  fontSMFamily: 'Helvetica Now Display',
  fontSMSize: '14px',
  fontSMLineHeight: '20px',
  fontSMSpacing: '0.3px',
  fontMDFamily: 'Helvetica Now Display',
  fontMDSize: '16px',
  fontMDLineHeight: '24px',
  fontMDSpacing: '0.5px',
  fontLGFamily: 'Helvetica Now Display',
  fontLGSize: '20px',
  fontLGLineHeight: '28px',
  fontLGSpacing: '0.5px',
  fontXLFamily: 'Helvetica Now Display',
  fontXLSize: '24px',
  fontXLLineHeight: '32px',
  fontXLSpacing: '0.5px',
  font2XLFamily: 'Helvetica Now Display',
  font2XLSize: '28px',
  font2XLLineHeight: '36px',
  font2XLSpacing: '0.5px',
  font3XLFamily: 'Helvetica Now Display',
  font3XLSize: '32px',
  font3XLLineHeight: '40px',
  font3XLSpacing: '0.5px',
  font4XLFamily: 'Helvetica Now Display',
  font4XLSize: '40px',
  font4XLLineHeight: '52px',
  font4XLSpacing: '0.5px',
  font5XLFamily: 'Helvetica Now Display',
  font5XLSize: '48px',
  font5XLLineHeight: '64px',
  font5XLSpacing: '0.5px',
  font6XLFamily: 'Helvetica Now Display',
  font6XLSize: '64px',
  font6XLLineHeight: '96px',
  font6XLSpacing: '0.5px',
  font7XLFamily: 'Helvetica Now Display',
  font7XLSize: '72px',
  font7XLLineHeight: '96px',
  font7XLSpacing: '0.5px',
  fontXSWeight: 300,
  fontSMWeight: 400,
  fontMDWeight: 500,
  fontLGWeight: 700
};
var _default = tokens;
exports.default = _default;